// @flow

import { location } from 'window';

import url from 'url';

import _ from 'lodash';

import ko from 'rgs-knockout';
import type {
	PureComputed,
} from 'rgs-knockout';

import server from 'server';

import { profile } from 'myrgs-auth-helpers';

import {
	PHYSICAL_INSURANT_PERSON,
	JURIDICAL_INSURANT_PERSON,
	COMPANY_CLIENT_ROLES,
} from 'known-user-roles';

import LkTypeStorageExecutor
from '../../../ko-component-myrgs-auth2-form/js/utils/lk-type-storage-executor';
import myDmsCleanupSessionStorage from '../../../myrgs-auth-helpers/helpers/cleanup-sessionStorage';

const LINKS = [{
	path: '/private/profile.wbp',
	text: 'Мой профиль',
	roles: [PHYSICAL_INSURANT_PERSON, JURIDICAL_INSURANT_PERSON],
}, {
	path: '/private/insurances.wbp',
	text: 'Мои страховки',
	roles: [PHYSICAL_INSURANT_PERSON, JURIDICAL_INSURANT_PERSON],
	specialConditions: [() => !profile.hasAnyRole(...COMPANY_CLIENT_ROLES)],
}, {
	path: '/private/accident.wbp',
	text: 'Страховой случай',
	roles: [PHYSICAL_INSURANT_PERSON, JURIDICAL_INSURANT_PERSON],
	specialConditions: [() => !profile.hasAnyRole(...COMPANY_CLIENT_ROLES)],
}];

type Options = {
	myrgsBaseUrl: string
};

export default class ViewModel {
	_lkTypeStorage: LkTypeStorageExecutor;

	IsLoggedIn: PureComputed<boolean> = ko.pureComputed(() => {
		return profile.IsAuthenticated();
	});

	Links: PureComputed<Array<{ href: string, text: string }>> = ko.pureComputed(() => {
		const myrgsHref = this.MyrgsHref();

		return _(LINKS)
			.filter(({ roles, specialConditions }) => {
				const profileHasRoles = profile.hasAnyRole(...roles);
				const conditionsAreMet = specialConditions
					? _.every(specialConditions, condition => condition())
					: true;

				return profileHasRoles && conditionsAreMet;
			})
			.map(({ path, text }) => ({
				href: url.format(_.extend(url.parse(myrgsHref), {
					pathname: path,
				})),
				text,
			}))
			.value();
	});

	MyrgsHref: PureComputed<string>;

	constructor ({ myrgsBaseUrl }: Options) {
		this.MyrgsHref = ko.constant(myrgsBaseUrl);

		this._updateProfile();

		this._lkTypeStorage = new LkTypeStorageExecutor();
	}

	_updateProfile () {
		profile.updateAtLeastOnce().done();
	}

	onLogoutClick () {
		server.my.cmsapi.lk.logout()
			.then(() => {
				location.reload();
			})
			.then(() => {
				this._lkTypeStorage.clear();
				myDmsCleanupSessionStorage();
			})
			.done();
	}
}
